import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { Eyebrow } from '../Section';
import { liveCities, plannedCities } from '../../data/cities';
export function LocationsStrip() {
  return <section className="paper-texture relative border-y border-line bg-paper" aria-label="Where we sit" data-id="element-108" data-mp="2an5hw52lsyu1">
      <div className="relative mx-auto grid w-full max-w-shell gap-10 px-5 py-16 sm:px-8 sm:py-20 lg:grid-cols-12 lg:gap-14" data-id="element-109" data-mp="1hwnj3g8wxjmf">
        <div className="lg:col-span-4" data-id="element-110" data-mp="1cydmd17jiayp">
          <Eyebrow data-id="element-111" data-mp="1czevv18wqpeb">Where we sit</Eyebrow>
          <h2 className="mt-4 font-serif text-h2 text-charcoal" data-id="element-112" data-mp="1qx3l0la0cip6">
            Two offices today. Nine cities by 2028.
          </h2>
          <p className="mt-4 text-[1.0625rem] leading-relaxed text-charcoal-600" data-id="element-113" data-mp="1mup3c4i2rozh">
            We open an office only when we have found a senior adviser willing to live in that city.
            Until then we travel — the research, the shelf and the reporting are identical wherever
            your family sits.
          </p>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/98a81db2-49ae-4fa5-9a98-af98aa907dfb.jpg" alt="A mid-sized Indian city skyline at golden hour" className="mt-8 hidden h-40 w-full rounded-sm border border-line object-cover lg:block" data-id="element-114" data-mp="dl2dkejsl8ay" />
        </div>

        <div className="lg:col-span-8" data-id="element-115" data-mp="riqu5a6ttta7">
          <h3 className="font-sans text-overline font-semibold uppercase text-charcoal-400" data-id="element-116" data-mp="3r19qfe6d45a7">
            Open now
          </h3>
          <ul className="mt-4 grid gap-x-8 sm:grid-cols-2" data-id="element-117" data-mp="3v23ec7jt1k33">
            {liveCities.map((city, index) => <Reveal as="li" key={city.name} delay={index * 0.05} data-id="element-118" data-mp="3tfr1m207msw" data-mpi={index}>
                <Link to="/locations" className="group flex items-baseline justify-between gap-4 border-b border-gold/30 py-4" data-id="element-119" data-mp="8n0u3sigf6yy">
                  <span data-id="element-120" data-mp="3cakaxzlvc40j">
                    <span className="font-serif text-xl text-charcoal transition-colors duration-200 ease-out-quint group-hover:text-gold-dark" data-id="element-121" data-mp="3c9rd5o4w0ouj">
                      {city.name}
                    </span>
                    <span className="ml-2 text-sm text-charcoal-400" data-id="element-122" data-mp="eh94c0756amd">{city.state}</span>
                  </span>
                  <span className="flex items-center gap-2 text-xs text-gold-dark" data-id="element-123" data-mp="sb9wgb3l8zdr">
                    Since {city.year}
                    <ArrowRightIcon className="h-3.5 w-3.5 opacity-0 transition-opacity duration-200 ease-out-quint group-hover:opacity-100" aria-hidden="true" data-id="element-124" data-mp="hzt7exsm6p9" />
                  </span>
                </Link>
              </Reveal>)}
          </ul>

          <h3 className="mt-10 font-sans text-overline font-semibold uppercase text-charcoal-400" data-id="element-125" data-mp="4jbjznsekxz1">
            Opening next
          </h3>
          <ul className="mt-4 grid gap-x-8 sm:grid-cols-2" data-id="element-126" data-mp="1kw01bst59bb4">
            {plannedCities.map((city, index) => <Reveal as="li" key={city.name} delay={Math.min(index, 4) * 0.03} data-id="element-127" data-mp="1g0ufsv3nlynk" data-mpi={index}>
                <Link to="/locations" className="group flex items-baseline justify-between gap-4 border-b border-line py-3.5" data-id="element-128" data-mp="1oe7c97fk51z9">
                  <span data-id="element-129" data-mp="1eimbfcm867r3">
                    <span className="text-[0.975rem] text-charcoal-600 transition-colors duration-200 ease-out-quint group-hover:text-charcoal" data-id="element-130" data-mp="1ejfbjuqohz09">
                      {city.name}
                    </span>
                    <span className="ml-2 text-xs text-charcoal-400" data-id="element-131" data-mp="278cu7yysxxtj">{city.state}</span>
                  </span>
                  <span className="text-xs text-charcoal-400" data-id="element-132" data-mp="2c75wev8n22ee">{city.year}</span>
                </Link>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}